<template>
  <div class="reset-password">
    <h3 v-if="title">{{ title }}</h3>
    <steps :current="current" :steps="steps" />
    <router-view :parent="routeName" />
  </div>
</template>
<script>
import Steps from '@/components/Steps'
// import { mapActions } from 'vuex'
export default {
  name: 'ResetPassword',
  components: {
    Steps
  },
  data() {
    return {
      routeName: ''
    }
  },
  created() {
    const matched = this.$route.matched
    this.routeName = matched[matched.length - 2].name
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.path.indexOf('/first/') > -1 || to.path.indexOf('/change_init_pwd/') > -1) {
  //     next()
  //   } else {
  //     if (this.routeName !== 'ForgetPwd') {
  //       this.$store.dispatch('Logout')
  //     } else {
  //       next()
  //     }
  //   }
  // },
  computed: {
    title() {
      let title
      switch (this.routeName) {
        case 'First':
          title = '首次登录，请您验证手机号码及修改初始密码'
          break
        case 'ChangeInitPwd':
          title = '登录密码为初始密码，请您修改密码'
          break
        case 'ForgetPwd':
        default:
          title = ''
          break
      }
      return title
    },
    current() {
      const regx = /step_(\d)$/
      const path = this.$route.path
      return +regx.exec(path)[1]
    },
    steps() {
      const { routeName } = this
      return [
        {
          step: 1,
          icon: 'hi-yanzhengshouji1',
          iconActive: 'hi-yanzhengshouji1',
          title: '验证手机'
        },
        {
          step: 2,
          icon: routeName === 'ForgetPwd' ? 'hi-zhongzhimima2' : 'hi-xiugaichushimima3',
          iconActive: routeName === 'ForgetPwd' ? 'hi-zhongzhimima2' : 'hi-xiugaichushimima3',
          title: routeName === 'ForgetPwd' ? '重置密码' : '修改初始密码'
        },
        {
          step: 3,
          icon: routeName === 'ForgetPwd' ? 'hi-zhongzhiwancheng2' : 'hi-xiugaiwancheng2',
          iconActive: routeName === 'ForgetPwd' ? 'hi-zhongzhiwancheng2' : 'hi-xiugaiwancheng',
          title: routeName === 'ForgetPwd' ? '重置完成' : '修改完成'
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.reset-password {
  // margin-top: 50px;
  position: absolute;
  top: 82px;
  right: 220px;
  bottom: 140px;
  left: 220px;
  border-radius: 4px;
  padding: 40px;
  // width: 1000px;
  // margin: 0 auto;
  background: #fff;
  box-shadow: 0 10px 14px 0 rgba(77, 83, 98, .06);
}
h3 {
  margin-bottom: 56px;
  font-size: 18px;
  text-align: center;
}
/deep/.ant-form-item-with-help {
  margin-bottom: 24px !important;
}
/deep/input#mobile {
  height: 36px !important;
}
/deep/input#verifyCode {
  height: 36px !important;
}
/deep/.ant-row.ant-form-item {
  height: 36px !important;
}
/deep/.ant-form-explain {
  margin-left: 14px;
}
</style>
